// extracted by mini-css-extract-plugin
export default {"mainContent":"layout_mainContent__vbXOs","asideHeader":"layout_asideHeader__K8NXh","imgLogo":"layout_imgLogo__JaPJc"};